import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { AppContext } from "../utilities/context";
import Styles from "../../public/assets/css/main.css";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import LocalConvenienceStoreIcon from "@mui/icons-material/LocalConvenienceStore";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import GroupsIcon from "@mui/icons-material/Groups";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules"; // Importa los módulos necesarios
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const items = [
  {
    image: "assets/images/qrflow/slide-home/01.jpg",
    textId: "app.home.slide1.slogan",
    bullets: [
      {
        icon: <AddShoppingCartIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet1",
      },
      {
        icon: <QueryStatsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet2",
      },
      {
        icon: <LocalConvenienceStoreIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet3",
      },
      {
        icon: <GroupsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet4",
      },
      {
        icon: <AssignmentReturnIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet5",
      },
    ],
  },
  {
    image: "assets/images/qrflow/slide-home/02.jpg",
    textId: "app.home.slide1.slogan",
    bullets: [
      {
        icon: <AddShoppingCartIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet1",
      },
      {
        icon: <QueryStatsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet2",
      },
      {
        icon: <LocalConvenienceStoreIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet3",
      },
      {
        icon: <GroupsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet4",
      },
      {
        icon: <AssignmentReturnIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet5",
      },
    ],
  },
  {
    image: "assets/images/qrflow/slide-home/03.jpg",
    textId: "app.home.slide1.slogan",
    bullets: [
      {
        icon: <AddShoppingCartIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet1",
      },
      {
        icon: <QueryStatsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet2",
      },
      {
        icon: <LocalConvenienceStoreIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet3",
      },
      {
        icon: <GroupsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet4",
      },
      {
        icon: <AssignmentReturnIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet5",
      },
    ],
  },
  {
    image: "assets/images/qrflow/slide-home/04.jpg",
    textId: "app.home.slide1.slogan",
    bullets: [
      {
        icon: <AddShoppingCartIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet1",
      },
      {
        icon: <QueryStatsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet2",
      },
      {
        icon: <LocalConvenienceStoreIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet3",
      },
      {
        icon: <GroupsIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet4",
      },
      {
        icon: <AssignmentReturnIcon fontSize="large" color="primary" />,
        textId: "app.home.slide1.bullet5",
      },
    ],
  },
];

const HomeQRFlow = ({ chatRef }) => {
  const context = useContext(AppContext);
  const intl = useIntl();
  const [tenantConfig, setTenantConfig] = useState(null);

  const handleChatInputClick = () => {
    document.activeElement?.blur();
    chatRef.current?.handleClickOpen();
  };

  useEffect(() => {
    if (context) {
      setTenantConfig(context.tenantConfig);
      context.updateBreadcrumbsState([]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          autoplay={{ delay: 5000 }}
          pagination={{ clickable: true }}
          navigation={true}
          spaceBetween={50}
          slidesPerView={1}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => console.log(swiper)}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                  <img src={item.image} className={"AppLogoHome"} alt="logo" />
                </Grid>
                <Grid item xs={12} md={6}>
                  <div style={{ paddingBottom: "20px" }}>
                    <FormattedMessage id={item.textId} />
                  </div>
                  {item.bullets && (
                    <List dense={true}>
                      {item.bullets.map((bullet, idx) => (
                        <ListItem key={idx}>
                          <ListItemIcon>{bullet.icon}</ListItemIcon>
                          <ListItemText
                            primary={intl.formatMessage({
                              id: bullet.textId,
                            })}
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Grid>
              </Grid>
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid>
      <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
        <Link to={"mailto:info@plopi.com.ar"}>
          <FormattedMessage id="app.footer.contact.title" />
        </Link>{" "}
        |{" "}
        <Link to={"/terms"}>
          <FormattedMessage id="app.terms.title" />
        </Link>{" "}
        |{" "}
        <Link to={"/privacy"}>
          <FormattedMessage id="app.privacy.title" />
        </Link>
      </Grid>
    </Grid>
  );
};

export default HomeQRFlow;
